import React, { useState } from 'react';
import { connect } from 'react-redux';
import { setSimCardType, setSelectedTransferOption } from '../../TransferOrganizationAccountSlice';
import { transferOption } from '../../Constant/Constant';
import SelectOptionButton from '../../../../Shared/SelectOptionButton/SelectOptionButton';

const SelectTransferLineComponent = (props) => {
  const transferLineOptions = [
    {
      id: '0',
      label: 'ניוד קו',
      value: transferOption.niud,
      selected: props.data.selectedTransferOption === transferOption.niud ? true : false,
    },
    {
      id: '1',
      label: 'קו חדש',
      value: transferOption.newLine,
      selected: props.data.selectedTransferOption === transferOption.newLine ? true : false,
    },
  ];

  return (
    <div className='transfer-line-sub-step borderline'>
      <SelectOptionButton title={'מה סוג הקו?'} buttonsData={transferLineOptions} onClick={props.setSelectedTransferOption} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.TransferOrganizationAccount,
  };
};

const mapDispatchToProps = {
  setSimCardType,
  setSelectedTransferOption,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectTransferLineComponent);
